/* Sparbude: a world stays with collection, brand, search and product navigation. */
(() => {
  'use strict';
  const context = document.getElementById('sb-context');
  if (!context) return;
  const cfg = JSON.parse(context.textContent);
  const worlds = {'sb-pack-einzelartikel':'Einzelartikel','sb-pack-gebinde':'Gebinde','sb-pack-spar-sets':'Sparsets'};
  const known = Object.keys(worlds);
  const url = new URL(location.href);
  let saved = '';
  try { saved = sessionStorage.getItem('sparbude-world') || ''; } catch (_) {}
  let world = worlds[cfg.world] ? cfg.world : (worlds[saved] ? saved : '');
  const base = cfg.base.replace(/\/$/, '');
  const tagsInPath = decodeURIComponent(url.pathname).split('/').pop().split('+');
  const routeWorld = tagsInPath.find(tag => worlds[tag]);
  if (routeWorld) world = routeWorld;
  if (world) {
    try { sessionStorage.setItem('sparbude-world', world); } catch (_) {}
    document.documentElement.dataset.sbWorld = world;
  }
  // Older unscoped assortment links must not silently open a mixed catalogue.
  if (cfg.page === 'collection' && !routeWorld &&
      (url.pathname === base || url.pathname.startsWith(base + '/') || /\/collections\/all\/?$/.test(url.pathname))) {
    if (world) {
      const tags = url.pathname.startsWith(base + '/') ? tagsInPath.filter(t => t.startsWith('sb-') && !known.includes(t)) : [];
      url.pathname = base + '/' + [world, ...tags].join('+');
      location.replace(url.href); return;
    }
    location.replace(cfg.root); return;
  }
  const scopeLink = a => {
    if (!world || a.hasAttribute('data-sb-switch')) return;
    let target;
    try { target = new URL(a.getAttribute('href'), location.origin); } catch (_) { return; }
    if (target.origin !== location.origin) return;
    const targetTags = decodeURIComponent(target.pathname).split('/').pop().split('+');
    const explicitWorld = targetTags.find(tag => known.includes(tag));
    if (explicitWorld) return;
    if (a.hasAttribute('data-sb-home')) target.pathname = base + '/' + world;
    else if (a.hasAttribute('data-sb-scope') || target.pathname === base || target.pathname.startsWith(base + '/') || /\/collections\/all\/?$/.test(target.pathname)) {
      let tags = target.pathname.startsWith(base + '/') ? decodeURIComponent(target.pathname.slice(base.length + 1)).split('+') : [];
      tags = tags.filter(t => t && t.startsWith('sb-') && !known.includes(t));
      target.pathname = base + '/' + [world, ...tags].join('+');
    } else return;
    const next = target.pathname + target.search + target.hash;
    if (a.getAttribute('href') !== next) a.setAttribute('href', next);
  };
  const refresh = () => {
    document.querySelectorAll('a[href]').forEach(scopeLink);
    document.querySelectorAll('[data-sb-label]').forEach(el => el.textContent = world ? worlds[world] : 'Deine Einkaufswelt');
    document.querySelectorAll('[data-sb-current]').forEach(el => el.textContent = world ? 'Du bist bei ' + worlds[world] : 'Wähle deine Einkaufswelt');
    document.querySelectorAll('[data-sb-menu]').forEach(el => el.hidden = !world);
    document.querySelectorAll('[data-sb-search] input[name="q"]').forEach(el => el.placeholder = world ? worlds[world] + ' durchsuchen …' : 'Produkte suchen …');
  };
  refresh();
  document.addEventListener('click', e => {
    const switcher = e.target.closest('[data-sb-switch]');
    if (switcher) {
      const nextWorld = switcher.dataset.sbSwitch;
      if (worlds[nextWorld]) {
        world = nextWorld;
        try { sessionStorage.setItem('sparbude-world', nextWorld); } catch (_) {}
        document.documentElement.dataset.sbWorld = nextWorld;
        if (e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
          e.preventDefault();
          e.stopPropagation();
          window.location.assign(switcher.href);
          return;
        }
      }
    }
    if (!e.target.closest('.sb-menu,.sb-world-switch')) document.querySelectorAll('.sb-menu details[open],.sb-world-switch[open]').forEach(d => d.open = false);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') document.querySelectorAll('.sb-menu details[open],.sb-world-switch[open]').forEach(d => { d.open = false; d.querySelector('summary').focus(); });
  });
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!d.open || !d.matches('.sb-menu details,.sb-world-switch')) return;
    [...d.parentElement.children].filter(x => x !== d && x.tagName === 'DETAILS').forEach(x => x.open = false);
  }, true);
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-sb-search]');
    if (!form) return;
    e.preventDefault();
    const term = form.querySelector('[name="q"]').value.trim();
    if (!term) return;
    const target = new URL(cfg.search, location.origin);
    // Treat entered text as literal terms, so tag/operator input cannot leave the chosen world.
    const safeTerm = term.replace(/[():"\\]/g, ' ').replace(/\b(?:AND|OR|NOT)\b/g, ' ').trim();
    if (!safeTerm) return;
    target.searchParams.set('q', world ? '(' + safeTerm + ') AND tag:' + world : safeTerm);
    target.searchParams.set('type', 'product');
    location.assign(target.href);
  });
  // Facet filtering and load-more can insert collection links after page load.
  let queued = false;
  const observer = new MutationObserver(records => {
    if (!records.some(r => [...r.addedNodes].some(n => n.nodeType === 1)) || queued) return;
    queued = true; requestAnimationFrame(() => { queued = false; refresh(); });
  });
  observer.observe(document.body, {childList:true, subtree:true});
})();

/* Sparbude: one continuously paginated catalog, in-stock products before out-of-stock. */
(() => {
  'use strict';
  const selector = '#JsCollectionProduct[data-sb-stock-order="enabled"]';
  const availabilityParam = 'filter.v.availability';
  const responseCache = new Map();
  let queued = false;

  function filteredUrl(stock, page) {
    const url = new URL(location.href);
    url.searchParams.set(availabilityParam, stock);
    url.searchParams.set('page', String(page));
    url.searchParams.delete('sections');
    url.searchParams.delete('section_id');
    return url.href;
  }

  function fetchPage(stock, page) {
    const url = filteredUrl(stock, page);
    if (!responseCache.has(url)) {
      const request = fetch(url, { credentials: 'same-origin' })
        .then(response => {
          if (!response.ok) throw new Error('Filtered collection HTTP ' + response.status);
          return response.text();
        })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const root = doc.querySelector(selector);
          if (!root) throw new Error('Availability filter not rendered');
          const count = Number(root.dataset.sbStockCount);
          if (!Number.isFinite(count) || count < 0) throw new Error('Invalid filtered product count');
          return {
            count,
            cards: Array.from(root.querySelectorAll('#product-grid .products__row > .products__col'),
              node => node.outerHTML)
          };
        })
        .catch(error => {
          responseCache.delete(url);
          throw error;
        });
      responseCache.set(url, request);
    }
    return responseCache.get(url);
  }

  async function sliceGroup(stock, start, end, size, firstPage) {
    if (start >= end) return [];
    const from = Math.floor(start / size) + 1;
    const to = Math.floor((end - 1) / size) + 1;
    const tasks = [];
    for (let page = from; page <= to; page++) {
      tasks.push(page === 1 ? firstPage : fetchPage(stock, page));
    }
    const pages = await Promise.all(tasks);
    const cards = pages.flatMap(result => result.cards);
    return cards.slice(start % size, start % size + (end - start));
  }

  function pageHref(page) {
    const url = new URL(location.href);
    url.searchParams.delete(availabilityParam);
    if (page === 1) url.searchParams.delete('page');
    else url.searchParams.set('page', String(page));
    return url.pathname + url.search + url.hash;
  }

  function buildPagination(page, totalPages, total, start, end) {
    const footer = document.createElement('div');
    footer.className = 'sb-stock-pager page-collection-footer';
    const count = document.createElement('p');
    count.className = 'sb-stock-pager__count';
    count.textContent = (start + 1) + '–' + end + ' von ' + total + ' Produkten';
    footer.appendChild(count);

    if (totalPages > 1) {
      const nav = document.createElement('nav');
      nav.className = 'sb-stock-pages';
      nav.setAttribute('aria-label', 'Produktseiten');
      function addPage(label, number, current, accessibleLabel) {
        const a = document.createElement('a');
        a.href = pageHref(number);
        a.textContent = label;
        if (accessibleLabel) a.setAttribute('aria-label', accessibleLabel);
        if (current) { a.setAttribute('aria-current', 'page'); a.classList.add('is-current'); }
        nav.appendChild(a);
      }
      if (page > 1) addPage('‹', page - 1, false, 'Vorherige Seite');
      const selected = new Set([1, totalPages]);
      for (let n = Math.max(1, page - 2); n <= Math.min(totalPages, page + 2); n++) selected.add(n);
      let previous = 0;
      Array.from(selected).sort((a, b) => a - b).forEach(number => {
        if (previous && number > previous + 1) {
          const ellipsis = document.createElement('span');
          ellipsis.textContent = '…';
          ellipsis.className = 'sb-stock-pages__ellipsis';
          nav.appendChild(ellipsis);
        }
        addPage(String(number), number, number === page, 'Seite ' + number);
        previous = number;
      });
      if (page < totalPages) addPage('›', page + 1, false, 'Nächste Seite');
      footer.appendChild(nav);
    }
    return footer;
  }

  async function render(root, row) {
    const url = new URL(location.href);
    // Explicit user-selected availability filters retain Shopify's normal filtering.
    if (url.searchParams.has(availabilityParam)) return;
    if (row.dataset.sbStockRendered === 'true' || root.dataset.sbStockLoading === 'true') return;

    const size = Math.max(1, Number(root.dataset.sbPageSize) || 24);
    const page = Math.max(1, Number.parseInt(url.searchParams.get('page') || '1', 10) || 1);
    root.dataset.sbStockLoading = 'true';
    root.classList.add('sb-stock-loading');
    try {
      const [availableFirst, unavailableFirst] = await Promise.all([
        fetchPage('1', 1),
        fetchPage('0', 1)
      ]);
      const availableTotal = availableFirst.count;
      const total = availableTotal + unavailableFirst.count;
      if (total === 0) return;
      const start = (page - 1) * size;
      if (start >= total) {
        location.replace(pageHref(1));
        return;
      }
      const end = Math.min(total, start + size);
      const availableStart = Math.min(start, availableTotal);
      const availableEnd = Math.min(end, availableTotal);
      const unavailableStart = Math.max(0, start - availableTotal);
      const unavailableEnd = Math.max(0, end - availableTotal);
      const [available, unavailable] = await Promise.all([
        sliceGroup('1', availableStart, availableEnd, size, availableFirst),
        sliceGroup('0', unavailableStart, unavailableEnd, size, unavailableFirst)
      ]);
      const template = document.createElement('template');
      template.innerHTML = available.concat(unavailable).join('');
      if (template.content.children.length !== end - start) {
        throw new Error('Incomplete availability page: falling back to original catalog');
      }
      const productGrid = root.querySelector('#ProductGridContainer #product-grid');
      if (!productGrid || !row.isConnected || !root.isConnected) return;
      row.dataset.sbStockRendered = 'true';
      row.replaceChildren(template.content);
      productGrid.querySelectorAll('.page-collection-footer').forEach(el => el.remove());
      productGrid.appendChild(buildPagination(page, Math.ceil(total / size), total, start, end));
    } catch (error) {
      // Keep the original unfiltered Shopify product grid if any request fails.
      console.warn('Sparbude stock-first sorting unavailable:', error);
      row.dataset.sbStockRendered = 'true';
    } finally {
      root.classList.remove('sb-stock-loading');
      delete root.dataset.sbStockLoading;
    }
  }

  function refresh() {
    const root = document.querySelector(selector);
    const row = root?.querySelector('#ProductGridContainer #product-grid .products__row');
    if (root && row && !row.dataset.sbStockRendered) render(root, row);
  }
  function scheduleRefresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  if (document.body) {
    // Shopify's facets replace the grid via AJAX; reapply stock order on replacement.
    new MutationObserver(scheduleRefresh).observe(document.body, { childList: true, subtree: true });
  }
})();
